export const REQUEST_QUIZ = 'REQUEST_QUIZ';
export const SET_CURRENT_QUIZ = 'SET_CURRENT_QUIZ';
export const RESET_CURRENT_QUIZ = 'RESET_CURRENT_QUIZ';
export const CHOOSE_ANSWER = 'CHOOSE_ANSWER';
export const SUBMIT_ANSWER = 'SUBMIT_ANSWER';
export const SUBMIT_ANSWER_SUCCESSFULL = 'SUBMIT_ANSWER_SUCCESSFULL';
